import "./NewPreviewUI.css";
import { PropagateLoader } from "react-spinners";
import { useSelector } from "react-redux";
import NewPreviewRightEditor from "./NewPreviewRightEditor";
const NewPreviewRightCustomisationDisplay = ({ showPreviewListData, targetScreenWidth,targetScreenHeight,layoutItem}) => {
  const previewData = useSelector((state) => state?.preview);

  return showPreviewListData == null ? (
    <div className="newPreviewRightCustomisationDisplay">
      <div className="newPreviewRightCustomisationLoaderContainer">
        <div className="newPreviewRightCustomisationLoader">
          <PropagateLoader color="white" />
        </div>
        <div className=""> We are preparing the previews...</div>
      </div>
    </div>
  ) : previewData?.previewObject == null &&
    previewData?.previewTemplateObject == null ? (
    <div className="newPreviewRightCustomisationDisplay">
      Please select a customisation to edit
    </div>
  ) : (
    <div className="newPreviewRightCustomisationDisplay">
      <NewPreviewRightEditor  targetScreenWidth={ targetScreenWidth} targetScreenHeight={targetScreenHeight} layoutItem={layoutItem} />
    </div>
  );
};

export default NewPreviewRightCustomisationDisplay;
